import { render, staticRenderFns } from "./NValidation.vue?vue&type=template&id=1efeb91a&scoped=true"
import script from "./NValidation.vue?vue&type=script&lang=js"
export * from "./NValidation.vue?vue&type=script&lang=js"
import style0 from "./NValidation.vue?vue&type=style&index=0&id=1efeb91a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efeb91a",
  null
  
)

export default component.exports